import { Icon20MagnifierMinusOutline, Icon20MagnifierPlusOutline } from '@vkontakte/icons';
import React, { FC } from 'react';

import styles from '../NormalizedConvertedViewerPdf.css';

interface Props {
    onIncreaseScaleClick: () => void;
    onDecreaseScaleClick: () => void;
    scale: number;
}

export const NormalizedPdfHeader: FC<Props> = ({ onIncreaseScaleClick, onDecreaseScaleClick, scale }) => (
    <div className={styles.header}>
        <div className={styles.zoomer}>
            <div onClick={onDecreaseScaleClick} className={styles.icon}>
                <Icon20MagnifierMinusOutline />
            </div>
            <p className={styles.zoomPercent}>{`${scale * 100}%`}</p>
            <div onClick={onIncreaseScaleClick} className={styles.icon}>
                <Icon20MagnifierPlusOutline />
            </div>
        </div>
    </div>
);
